// Dashboard-Zugänge. Gezählt werden die Mitglieder, die /settings/user anzeigt
// (toMember in components/settings/user-management.js). Das sind EMPLOYEE-Spaces
// mit person, eingeladene und noch nicht eingeloggte Personen eingeschlossen.
// Spaces ohne person sind kaputte Datensätze, die Liste blendet sie aus.

export const countsAsSeat = (space) =>
  !!space && space.context === 'EMPLOYEE' && !!space.person

export const countSeats = (spaces) =>
  (Array.isArray(spaces) ? spaces : []).filter(countsAsSeat).length
